import React, { useEffect, lazy, Suspense } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import InitComponent from './containers/InitComponent';
import {
  getFromLocalStorage,
  getUpdatedRefreshToken,
  setToLocalStorage,
} from './global/helpers';
import useRefreshToken from './global/hooks/useRefreshToken';

const LoyaltyTrainerPage = lazy(
  () => import('./containers/LoyaltyTrainerPage')
);

const App = () => {
  const ru = require('./global/translations/ru.json');

  useEffect(() => {
    if (!getFromLocalStorage('lang')) {
      setToLocalStorage('lang', 'ru');
    }
  }, []);

  useRefreshToken(() => {
    getUpdatedRefreshToken();
  }, []);

  i18n.use(initReactI18next).init({
    resources: {
      ru,
    },
    lng: getFromLocalStorage('lang'),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
  });

  useEffect(() => {
    const skyRoot = document.getElementById('wt-sky-root');
    if (skyRoot) {
      skyRoot.remove();
    }
  }, []);

  return (
    <Router>
      <Switch>
        {process.env.NODE_ENV !== 'production' &&
        process.env.REACT_APP_LOYALTY_TRAINER_PREVIEW === 'true' &&
        window.location.pathname === '/trainer-preview' ? (
          <Suspense fallback={<p role="status">Загрузка тренажёра…</p>}>
            <LoyaltyTrainerPage />
          </Suspense>
        ) : (
          <InitComponent />
        )}
      </Switch>
    </Router>
  );
};

export default Sentry.withProfiler(App);
